import React from "react";
import "./bio.css";

function Bio() {
    return(
        <div className="bioContainer">
            <div className="photoAndLinks">
                <div className="bioImageBox">
                    <img src="./images/misc/chipbing.jpg" className="bioImage" alt="Charles Bingham - artist" />
                </div>
                <div className="sideBySideBio">
                    <div className="linkBox">
                        <figcaption className="figureCaption">
                            Read an article about my work. (I made the cover photo)
                        </figcaption>
                        <a href="./images/misc/classicyachtnovdec2011edit.pdf">
                            <img src="./images/misc/classicYachtLogo2.jpg" className="doubleLogos" alt="This will take you to an issue of Classic Yacht Magazine where there is an article about my artwork." />
                        </a>
                    </div>
                    <br></br>
                    <div className="linkBox">
                        <figcaption className="figureCaption">
                            Read about a client's experience having a custom piece of art created.
                        </figcaption>
                        <a href="https://www.woodyboater.com/blog/2011/07/26/the-teeny-tiny-world-and-the-enormous-artistry-of-charles-bingham/">
                            <img src="./images/misc/woodyBoaterLogo2.jpg" className="doubleLogos" alt="This will take you to an article written by a client about his experience commissioning a custom piece of marquetry artwork." />
                        </a>
                    </div>
                </div>
            </div>
            <div className="bioText" data-aos="fade-up">
                I am a Michigan resident who creates pictoral art using wood. This unique artform is called marquetry (mar-ket-tree). It involves hand-cutting pieces of wood with different grain-patterns and colors shaped to resemble each element in the image. While the design phase is a free-flowing act of inspiration, the creation process is a meticulous and precise execution of skill.
            </div>
                <br></br>
            <div className="bioText" data-aos="fade-up">
                Many exotic woods from around the world are used to get a good mix of colors and grain-patterns that can closely represent each element in the image. There are NO stains used in this tecnique, and all of the colors you see are the natural wood tones with a clear protective finish applied.
            </div>
            <div className="bioText" data-aos="fade-up">
                With a background in both art and woodworking, marquetry seemed to be the most creative way of utilizing all of my talents. I am mostly self-taught, as there are few people in the United States that do this type of artwork. It has a very deep history and tradition in Europe, where I have received much advice and guidance in perfecting my art. I belong to both the Marquetry Society of England and the American Marquetry Society.
            </div>
                <br></br>
            <div className="bioText" data-aos="fade-up">
                The uniqueness of this medium is a point of intrigue for those who wish to own something that is both beautiful and out of the ordinary. What I like most about working with wood lies in how the natural and exotic graiin-patterns can often look like other natural elements of a picture. I can create visual effects that would look flat and lifeless if it were a painting. Many woods have a texture and a luster that changes depending on the angle of light and the vantage point of the viewer. These interesting aspects of wood marquetry make make the creative process exciting for the artist and the finished result alluring to see.
            </div>
            <div className="bioBottomBox" data-aos="fade" data-aos-duration="3000">
                <img src="./images/misc/headshotwithartwork4K.jpg" className="wideImage" alt="Charles Bingham - artist" />
            </div>
            <br></br>
        </div>
    );
};

export default Bio;